// Real content — Bros On Board portfolio
export const BRAND = {
    name: 'Bros On Board',
    tagline: 'Wedding films, directed.',
    phone: '+91 90634 13153',
    phoneRaw: '919063413153',
    email: 'balu.cine.arts@gmail.com',
    whatsapp: 'https://wa.me/919063413153',
    instagram: 'https://instagram.com',
    youtube: 'https://youtube.com',
};

// Public artifact URL for the real wedding film
export const SIGNATURE_FILM = {
    id: 'signature',
    title: 'Of Waterfalls & Vows',
    subtitle: 'A Pre-Wedding Film · Shot on Location',
    chapter: 'Signature Film 2026',
    location: 'South India',
    runtime: '3:27 · 2026',
    synopsis:
        "Not just a film. A keepsake they'll return to for life. Quiet glances, a stolen laugh, and love shot in small, honest frames.",
    videoUrl:
        'https://customer-assets-gfyr7b9c.emergentagent.net/job_film-your-day/artifacts/8d8081ccc90d60f1_asd.mp4',
    poster: '/films/nf4.jpg',
    // Bento gallery of stills pulled from the film itself
    stills: [
        { src: '/films/nf4.jpg', aspect: 'landscape', caption: 'The Waterfall · Act II' },
        { src: '/films/nf6.jpg', aspect: 'portrait', caption: 'The Smile · Act III' },
        { src: '/films/atirapally.webp', aspect: 'landscape', caption: 'The Falls · Act I' },
        { src: '/films/frame5.jpg', aspect: 'portrait', caption: 'Golden Hour · Act III' },
        { src: '/films/nf3.jpg', aspect: 'landscape', caption: 'The Road · Opening' },
        { src: '/films/frame1.jpg', aspect: 'landscape', caption: 'The Ocean · Interlude' },
    ],
};

// Hero still — the strongest frame from the real film
export const HERO_IMAGE = '/films/nf4.jpg';

export const PORTFOLIO = [
    { id: 'rp1', cat: 'Wedding Films', title: 'Ritual · The Coconut', image: '/portfolio/p5_waterfall.webp' },
    { id: 'rp2', cat: 'Wedding Films', title: 'Maybe It Means Something More', image: '/portfolio/p4_mountain.webp' },
    { id: 'rp3', cat: 'Wedding Photography', title: 'The Bridal Procession', image: '/portfolio/p3_brides.webp' },
    { id: 'rp4', cat: 'Wedding Films', title: 'Misty Mountain Vow', image: '/portfolio/p1_ritual.webp' },
    { id: 'rp5', cat: 'Wedding Films', title: 'The Waterfall Embrace', image: '/portfolio/p2_window.webp' },
    { id: 'p1', cat: 'Wedding Films', title: 'The Waterfall', image: '/films/nf4.jpg' },
    { id: 'p2', cat: 'Wedding Photography', title: 'The Smile', image: '/films/nf6.jpg' },
    { id: 'p3', cat: 'Wedding Films', title: 'Barefoot Vows', image: '/films/frame4.jpg' },
    { id: 'p4', cat: 'Wedding Photography', title: 'Golden Hour', image: '/films/frame5.jpg' },
    { id: 'p5', cat: 'Wedding Films', title: 'The Opening Road', image: '/films/nf3.jpg' },
    { id: 'p6', cat: 'Wedding Films', title: 'Ocean Interlude', image: '/films/frame1.jpg' },
    { id: 'p7', cat: 'Wedding Photography', title: 'Mountain Mist', image: '/films/frame3.jpg' },
    { id: 'p8', cat: 'Wedding Films', title: 'Walking Away', image: '/films/nf7.jpg' },
    { id: 'p9', cat: 'Commercial', title: 'Monsoon Light Test', image: '/films/frame2.jpg' },
];

export const PORTFOLIO_CATEGORIES = ['All', 'Wedding Films', 'Wedding Photography', 'Commercial'];

export const PROCESS = [
    {
        step: '01',
        title: 'Pre-Production',
        body: 'We meet, listen, and storyboard. Every wedding gets a treatment document — characters, beats, and a mood reel — like a real film.',
        image: '/portfolio/p1_ritual.webp',
    },
    {
        step: '02',
        title: 'Cinematic Shoot',
        body: 'Anamorphic lenses, gimbals, and a directed eye. We block the day like a feature — coverage, character, and atmosphere.',
        image: '/portfolio/p5_waterfall.webp',
    },
    {
        step: '03',
        title: 'Score & Edit',
        body: 'Cut to a custom score. We grade in DaVinci — teal-amber for joy, low-key for the still moments. The result is a film, not a recap.',
        image: '/portfolio/p3_brides.webp',
    },
];

export const TESTIMONIALS = [
    {
        quote: 'They didn’t shoot our wedding. They directed it. The film made my mother cry — twice.',
        who: 'Meera S.',
        where: 'Bride · Udaipur',
    },
    {
        quote: 'I have watched the trailer 47 times. It feels like a Netflix opener about us.',
        who: 'Kabir R.',
        where: 'Groom · Goa',
    },
    {
        quote: 'Bros On Board are storytellers first, cinematographers second. That’s the difference.',
        who: 'Studio Maison No.7',
        where: 'Brand Client',
    },
];

export const ABOUT_PORTRAIT = '/portfolio/p7_hands.webp';
